export var LoginMethod;
(function (LoginMethod) {
    LoginMethod["EmailCode"] = "EMAIL_CODE";
    LoginMethod["Password"] = "PASSWORD";
})(LoginMethod || (LoginMethod = {}));
export var AuthorizationChannel;
(function (AuthorizationChannel) {
    AuthorizationChannel["Email"] = "EMAIL";
})(AuthorizationChannel || (AuthorizationChannel = {}));
export const UserRequestCodeFailureMessage = {
    PasswordLoginRequired: 'passwordLoginRequired',
    Other: 'other',
};
export const UserConvertTemporaryUserFailureReason = {
    UserIsNotTemporary: 'userIsNotTemporary',
    Other: 'other',
};
export const UserApplyReferralCodeFailureReason = {
    ReferralCodeNotFound: 'referralCodeNotFound',
    CannotReferThemselves: 'cannotReferThemselves',
    AlreadyReferred: 'alreadyReferred',
    AlreadyPartner: 'alreadyPartner',
    Other: 'other',
};
